import { useDesktop } from "../../Components/Common/IsDesktop";
import ConnectionDetails from "./ConnectionDetails";
import ConnectionDetailsMobile from "./ConnectionDetailsMobile";
import { useState, useEffect } from "react";

const ConnectionDetailsWrapper = (props) => {
    const isDesktop = useDesktop();
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        // Small delay to ensure the hook has properly initialized
        const timer = setTimeout(() => {
            setIsInitialized(true);
        }, 10);

        return () => clearTimeout(timer);
    }, []);

    // Don't render anything until the desktop check is properly initialized
    if (!isInitialized) {
        return null; // or a loading spinner if you prefer
    }

    if (isDesktop) {
        return <ConnectionDetails {...props} />;
    } else {
        return <ConnectionDetailsMobile {...props} />;
    }
};

export default ConnectionDetailsWrapper;